var zoom=8;
$(document).ready(function(){
	$('#header').addClass('locations-page');

	$('#nearest #openServicesFuels').on('click',function(){
		$('#servicesFuels').slideToggle(300);
	});
	$('#nearest #openFuels,#nearest #openServices').on('click',function(){
		$('#nearest #fuels,#nearest #services,#nearest #applyBtns').slideToggle(300);
	});

	$('#nearest .apply').on('click',function(){
		$('#nearest #fuels,#nearest #services,#nearest #applyBtns').slideUp(300);
		$('#servicesFuels').slideUp(300);
		// $('#nearest .search-input input').trigger('keyup');
	});

	$('#nearest .cancel').on('click',function(){
		$('#nearest #services input:radio,#nearest #fuels input:radio').prop('checked', false);
		$('#nearest #fuels,#nearest #services,#nearest #applyBtns').slideUp(300);
		$('#servicesFuels').slideUp(300);
		// $('#nearest .search-input input').trigger('keyup');
	});

	$('#results .apply').on('click',function(){
		$('#results #filters').slideUp(300);
		$('#results').removeClass('open');
		performSearch('',$('#results #services').find('input:checked'),$('#results #fuels').find('input:checked'),true);
		// $('#results .search-input input').trigger('keyup');
	});

	$('#results .cancel').on('click',function(){
		$('#results #filters').slideUp(300);
		$('#results').removeClass('open');
		$('#results #services input:radio,#results #fuels input:radio').prop('checked', false);
		performSearch('',[],[],true);
		// $('#results .search-input input').trigger('keyup');
	});

	$('#results #services input:radio,#results #fuels input:radio,#nearest #services input:radio,#nearest #fuels input:radio').on('click',function(){
		let $this=$(this);
		if($this.attr('data-waschecked')=='true'){
			$this.prop('checked', false);
			$this.attr('data-waschecked', false);
		}	else{
			$this.attr('data-waschecked', true);
		}
	});

	$('#nearest #openFilters').on('click',function(){
		$('#nearest #filters').slideToggle(300);
		// $('#nearest #results').toggleClass('open');
	});

	$('#results #openFilters').on('click',function(){
		$('#results #filters').slideToggle(300);
		$('#results').toggleClass('open');
		// $('#results #results').toggleClass('open');
	});

	$('#locations').on('click','.fuels a,.drive-thru a,.delivery-services a',function(){
		$(this).toggleClass('open').next().slideToggle(300);
	});

	 const input = document.getElementById('autocomplete');
	 const input2 = document.getElementById('autocomplete2');
		const options={
  componentRestrictions: { country: "au" },
  strictBounds: false,
  types: ["postal_code","locality"],
};
   const autocomplete = new google.maps.places.Autocomplete(input,options);
   const autocomplete2 = new google.maps.places.Autocomplete(input2,options);
   autocomplete.addListener("place_changed", fillInAddress);
   autocomplete2.addListener("place_changed", fillInAddress2);

   function fillInAddress(){
   	const place = autocomplete.getPlace();
   	userLat=place.geometry.location.lat();
   	userLng=place.geometry.location.lng();
   	showResults(true,true);
   }
   function fillInAddress2(){
   	const place = autocomplete2.getPlace();
   	userLat=place.geometry.location.lat();
   	userLng=place.geometry.location.lng();
   	showResults(true,false);
   }

	function showResults(userLoc,firstPage){
		$('#nearest').hide();
		$('#results').show();
		$('#googleMap').addClass('results-shown');
		if(userLoc){
			const mapUserLoc=new google.maps.LatLng(userLat, userLng);
			var service = new google.maps.DistanceMatrixService();
			let numbrr=0;
			$.each(addresses,function(i,elem){
				const resultLoc=$('#locations .location[data-index='+i+']');
				const destination=new google.maps.LatLng(elem.lat, elem.lng);
				service.getDistanceMatrix({
					origins: [mapUserLoc],
					destinations: [destination],
					travelMode: 'DRIVING',
				}, function distanceCallback(response, status) {
					if(status=='OK'){
						$.each(response.rows,function(i2,elem2){
							$.each(elem2.elements,function(i3,elem3){
								if(elem3.status=='OK'){
									numbrr++;
									resultLoc.attr('data-distance',elem3.distance.value);
									resultLoc.find('.distance span').text(elem3.distance.text);
									if(numbrr==addresses.length){
										sortResults();
									}
								}
							});
						});
					}
				});
			});
			
		}
		if(firstPage){
			performSearch('',$('#nearest #services').find('input:checked'),$('#nearest #fuels').find('input:checked'),false);
		}else{
			performSearch('',$('#results #services').find('input:checked'),$('#results #fuels').find('input:checked'),false);
		}
	}
	function sortResults(){
		var divList = $("#locations .location");
		divList.sort(function(a, b){
			return parseInt($(a).attr("data-distance"))-parseInt($(b).attr("data-distance"))
		});
		$("#locations").html(divList);
		showResultMarkers(true)
	}
	

	

	$('#nearby').on('click',function(){
		getLocation();
	})

	$('#locations').on('mouseenter','.location',function(){
		var $this=$(this);
		let $index=$this.attr('data-index');

		// new google.maps.event.trigger( markers[$index], 'click' );
		$this.addClass('active').siblings().removeClass('active')
		map.panTo(markers[$index].getPosition());
		openInfoWindow(markers[$index],infoWindows[$index]);
	});

	$('#backBtn').on('click',function(){
		$('#nearest').show();
		$('#results').hide();
		$('#googleMap').removeClass('results-shown');
	});

	function getLocation() {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(showPosition, showError);
		} else { 
			console.log("Geolocation is not supported by this browser.");
			showResults(false,true);
		}
	}
	getLocation();
	let userLat=-37.8688019;
	let userLng=144.7034638;

	function showPosition(position) {
		userLat=position.coords.latitude;
		userLng=position.coords.longitude;
		// latlng for sydney TESTING..
		// userLat=-33.870453;
		// userLng=151.208755;
		showResults(true,true);
	}
	function showError(error) {
		switch(error.code) {
			case error.PERMISSION_DENIED:
			console.log("User denied the request for Geolocation.")
			break;
			case error.POSITION_UNAVAILABLE:
			console.log("Location information is unavailable.")
			break;
			case error.TIMEOUT:
			console.log("The request to get user location timed out.")
			break;
			case error.UNKNOWN_ERROR:
			console.log("An unknown error occurred.")
			break;
		}
		showResults(false,true);
	}
	

	function getDistanceFromLatLonInKm(lat1,lon1,lat2,lon2) {
		var R = 6371;
		var dLat = deg2rad(lat2-lat1);
		var dLon = deg2rad(lon2-lon1); 
		var a = 
		Math.sin(dLat/2) * Math.sin(dLat/2) +
		Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * 
		Math.sin(dLon/2) * Math.sin(dLon/2)
		; 
		var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
		var d = R * c;
		return d;
	}

	function deg2rad(deg) {
		return deg * (Math.PI/180)
	}

	function hasSubArray(master, sub) {
		return sub.every((i => v => i = master.indexOf(v, i) + 1)(0));
    // return sub.some((i => v => i = master.indexOf(v, i) + 1)(0));
  }

  function performSearch(searchText,services,fuels,changeMapMarkers){
  	var resultLocation=$('#nearest .search-input .search-results');
  	resultLocation.html('').hide();
  	$('#locations .location').hide();
  	var results=[];

  	var selectedServices=[];
  	var selectedFuels=[];

  	// if(!searchText && !changeMapMarkers){
  	// 	return false;
  	// }
  	$.each(services,function(j,service){
  		let serviceVal=$(service).val()
  		selectedServices.push(serviceVal);
  		$('#results #services input:radio[value='+serviceVal+']').prop('checked', true);
  	});
  	$.each(fuels,function(j,fuel){
  		let fuelVal=$(fuel).val();
  		selectedFuels.push(fuelVal);
  		$('#results #fuels input:radio[value='+fuelVal+']').prop('checked', true);
  	})

  	$.each(addresses,function(i,elem){
  		// if(elem.postcode.toLowerCase().includes(searchText) || elem.suburb.toLowerCase().includes(searchText)){

  			var serviceFilterCheck=false,fuelFilterCheck=false;


  			if(hasSubArray(elem.services,selectedServices)){
  				serviceFilterCheck=true;
  			}
  			if(hasSubArray(elem.fuels,selectedFuels)){
  				fuelFilterCheck=true;
  			}

  			if((serviceFilterCheck || !services.length) && (fuelFilterCheck||!fuels.length)){
  				results.push('<span class="suburb">'+elem.suburb+'</span> (<span class="postcode">'+elem.postcode+'</span>)');
  				$('#locations .location[data-index='+i+']').show();
  			}

  		// }
  	});
  	resultLocation.show();
  	if(results.length){
  		let uniqueResults = [];
  		$.each(results,function(i,result){
  			if (!uniqueResults.includes(result)) {
  				uniqueResults.push(result);
  			}
  		});
  		$.each(uniqueResults.slice(0, 5),function(i,result){
  			resultLocation.append('<a class="dropdown-item" href="javascript:;">'+result+'</a>');
  		});
  	}else{
  		resultLocation.append('<a class="dropdown-item not-clickable" href="javascript:;">No Results</a>');
  	}
  	if(changeMapMarkers){
  		showResultMarkers(searchText,services.length,fuels.length);
  	}
  }

  function showResultMarkers(searchText,service,fuel){
  	$('#locations .location').each(function(i,elem){
  		var $elem=$(elem);
  		var index=$elem.attr('data-index');

  		if(infoWindows[index]){
  			infoWindows[index].close();
  		}
  		if(markers[index]){
  			if($elem.is(':visible')){
  				markers[index].setMap(map);
  			}else{
  				markers[index].setMap(null);
  			}
  		}
  	});
  		if($('#locations .location:visible').length){
  			var index=$('#locations .location:visible').first().attr('data-index');
  			if(markers[index]){
  				map.setCenter(new google.maps.LatLng(markers[index].position.lat(),markers[index].position.lng()));
  				map.setZoom(12);
  				new google.maps.event.trigger( markers[index], 'click' );
  			}
  		}
  	 else{
  		// $('#locations .location').show();
  		map.setCenter(new google.maps.LatLng(-37.8136,144.9631));
  		map.setZoom(zoom);
  		return;
  	}
  }





});

window.myMap=function myMap() {
	var mapCenter=new google.maps.LatLng(-37.8136,144.9631);

	var mapProp= {
		center:mapCenter,
		disableDefaultUI:true,
		scrollwheel: true,
		panControl: false,
		zoomControl: true,
		mapTypeControl: false,
		scaleControl: false,
		streetViewControl: false,
		overviewMapControl: false,
		rotateControl: false,
		zoom:zoom,
	};
	map = new google.maps.Map(document.getElementById("googleMap"),mapProp);
	initGeoAddresses();

}

addMarkers=function addMarkers(i,lat,lng,elem){
	var location=new google.maps.LatLng(lat,lng);
	var markerData = {
		position: location,
		map: map,
		title: elem.title+'<br>'+elem.address,
		icon:siteUrl+'/images/marker.svg'
	}
	var marker = new google.maps.Marker(markerData);
	var infoWindow = new google.maps.InfoWindow();
	infoWindow.setContent('<div class="custom-info-window"><h6>'+elem.title+'</h6></div>');

	marker.addListener("click", () => {
		openInfoWindow(marker,infoWindow);
		let selectedLocation=$('#locations .location[data-index='+i+']');
		let $locations=$('#locations');
		let currentScroll=$locations.scrollTop();
		selectedLocation.addClass('active').siblings().removeClass('active');
		
		$locations.animate({
			scrollTop:currentScroll+selectedLocation.offset().top-$locations.offset().top
		});
	});
	markers[i]=marker;
	infoWindows[i]=infoWindow;
}

function openInfoWindow(marker,infoWindow){
	if(prevInfoWindow){
		prevInfoWindow.close();
	}
	prevInfoWindow=infoWindow;
	infoWindow.open({
		anchor: marker,
		map,
		shouldFocus: false,
	});
}
initGeoAddresses=function initGeoAddresses(){

	$.getJSON("/addresses.json", function(jsonAddresses) {
		console.log(jsonAddresses);
		var existingAddressesArray=[];
		$.each(jsonAddresses,function(i,elem){
			existingAddressesArray.push(elem.address);
		});

		console.log(addresses);
		$.each(addresses,function(i,elem){
			if(existingAddressesArray.includes(elem.address)){
				addresses[i].lat=jsonAddresses[existingAddressesArray.indexOf(elem.address)].lat;
				addresses[i].lng=jsonAddresses[existingAddressesArray.indexOf(elem.address)].lng;
				addMarkers(i,addresses[i].lat,addresses[i].lng,elem);
			}else{
				getGeocodes(i,elem);
			}
		})
	});



	// $.each(addresses,function(i,elem){
	// 	$.getJSON("https://maps.googleapis.com/maps/api/geocode/json?address="+elem.address+"&key="+geocodeKey, function(resp) {
	// 		if(resp.status=="OK"){
	// 			addresses[i].lat=resp.results[0].geometry.location.lat;
	// 			addresses[i].lng=resp.results[0].geometry.location.lng;
	// 			addMarkers(i,addresses[i].lat,addresses[i].lng,elem);
	// 		}else{
	// 			console.log(elem.address+' location not found');
	// 		}
	// 	})
	// });
}
function getGeocodes(i,elem){
	$.ajax({
		url: '/get-geocode.php',
		type: 'POST',
		data:{address:elem.address,geocodeKey:geocodeKey},
		success: function (resp) {
			let result=JSON.parse(resp);
			addresses[i].lat=result.lat;
			addresses[i].lng=result.lng;
			addMarkers(i,addresses[i].lat,addresses[i].lng,elem);
		}
	})
}
